import { render, staticRenderFns } from "./conclusionDialog.vue?vue&type=template&id=5965fe03&scoped=true"
import script from "./conclusionDialog.vue?vue&type=script&lang=js"
export * from "./conclusionDialog.vue?vue&type=script&lang=js"
import style0 from "./conclusionDialog.vue?vue&type=style&index=0&id=5965fe03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965fe03",
  null
  
)

export default component.exports